/** @format */

import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';

import { FavoritesLocationEnum } from '@shared/favorites/data-access/enums';
import { ISnackbarInfo } from '@shared/data-access/interfaces';
import { SnackbarService } from '@shared/data-access/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthLinkModule } from '@shared/authentication/utils';
import { CommonModule } from '@angular/common';
import {
	HomefieldIconLibraryModule,
	homefieldIconSignCancel,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'shared-components-auth-snackbar',
	templateUrl: './snackbar.component.html',
	styleUrl: './snackbar.component.scss',
	imports: [AuthLinkModule, CommonModule, HomefieldIconLibraryModule]
})
export class SnackbarComponent implements OnInit, OnDestroy {
	private readonly snackbarService = inject(SnackbarService);
	public homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconSignCancel]);
	}

	@Input() location: FavoritesLocationEnum;
	snackbarInfo: ISnackbarInfo;
	timer = null;
	private ngUnsubscribe: Subject<void> = new Subject();

	get analyticsEventData(): any {
		return {
			event: 'Signed out athlete clicked Favorites from:',
			value: this.location
		};
	}

	ngOnInit(): void {
		this.snackbarService.snackbar
			.pipe(takeUntil(this.ngUnsubscribe))
			.subscribe((snackbarInfo: ISnackbarInfo) => {
				this.snackbarInfo = snackbarInfo;
				if (this.snackbarInfo.showSnackbar) {
					this.timer = setTimeout(() => {
						this.snackbarService.hideSnackBar();
						clearTimeout(this.timer);
					}, 4250);
				}
			});
	}

	get hasBannerElement() {
		const bannerItemElement = document.getElementById('branch-banner-iframe');
		return bannerItemElement ? true : false;
	}

	ngOnDestroy(): void {
		if (this.timer) {
			clearTimeout(this.timer);
		}

		// set snackbar to default state when destroyed
		this.snackbarService.hideSnackBar();

		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}

	clearTimer() {
		clearTimeout(this.timer);
	}

	startTimer() {
		if (this.timer) {
			clearTimeout(this.timer);
		}
		this.timer = setTimeout(() => {
			this.snackbarService.hideSnackBar();
		}, 3400);
	}

	exitSnackbar() {
		if (this.timer) {
			clearTimeout(this.timer);
		}
		this.snackbarService.hideSnackBar();
	}
}
